import { ARAM_CONFIG } from './aramRules.js';

/** Fixed ARAM champion death timer (FID-CBT-01 minimal contract). */
export const ARAM_CHAMPION_RESPAWN_BASE_SEC = 12;

export function aramFountainPos(team) {
  return ARAM_CONFIG.spawnPlatforms[team] || ARAM_CONFIG.spawnPlatforms.blue;
}

/** Start death→fountain countdown. No-op if alive. */
export function scheduleAramChampionRespawn(entity, delaySec = ARAM_CHAMPION_RESPAWN_BASE_SEC) {
  if (!entity || !entity.isDead) return false;
  const delay = Number.isFinite(delaySec) ? Math.max(0, delaySec) : ARAM_CHAMPION_RESPAWN_BASE_SEC;
  entity.aramRespawnTimer = delay;
  return true;
}

/** Tick timer; on expiry call entity.respawn at team fountain. */
export function tickAramChampionRespawn(entity, dt = 0) {
  if (!entity?.isDead) return false;
  if (!Number.isFinite(entity.aramRespawnTimer)) return false;
  entity.aramRespawnTimer -= dt;
  if (entity.aramRespawnTimer > 0) return false;
  const pad = aramFountainPos(entity.team);
  if (typeof entity.respawn === 'function') {
    entity.respawn(pad.x, pad.z);
  }
  entity.aramRespawnTimer = 0;
  return true;
}
